import React, { useEffect, useRef } from "react";
import gsap from "gsap";
import Magnetic from "../Magnetic/index";

export default function AnimatedButton({
  children,
  className,
  effect,
}) {
  const circle = useRef(null);
  const timeline = useRef(null);
  const timeoutId = useRef(null); // Using useRef for timeout to keep its value persistent across renders.

  useEffect(() => {
    timeline.current = gsap.timeline({ paused: true });
    timeline.current
      .to(
        circle.current,
        { top: "-25%", width: "150%", duration: 0.4, ease: "power3.in" },
        "enter"
      )
      .to(
        circle.current,
        { top: "-150%", width: "125%", duration: 0.25 },
        "exit"
      );

    return () => {
      if (timeoutId.current) clearTimeout(timeoutId.current); // Clear any pending timeouts on unmount
      timeline.current.kill(); // Kill the GSAP timeline to avoid memory leaks
    };
  }, []);

  const manageMouseEnter = () => {
    if (timeoutId.current) clearTimeout(timeoutId.current);
    timeline.current.tweenFromTo("enter", "exit");
  };

  const manageMouseLeave = () => {
    timeoutId.current = setTimeout(() => {
      timeline.current.play();
    }, 300);
  };

  return (
    <Magnetic>
      <div
        className={`relative flex items-center justify-center p-[15px_60px] rounded-full cursor-pointer overflow-hidden ${className}`}
        onMouseEnter={manageMouseEnter}
        onMouseLeave={manageMouseLeave}
      >
        {children}
        <div
          ref={circle}
          className={`absolute rounded-full top-full ${effect}`}
        ></div>
      </div>
    </Magnetic>
  );
}
